<template>
  <div>
    <div class="row mt-4">
      <div class="col">
        <div class="card custom-form__card">
          <div class="card-header d-flex justify-content-between">
              <h5>
                  Configurações
              </h5>
          </div>
          <div class="card-body">
            <div class="row mb-2">
              <div class="col">
                <button
                  type="button"
                  class="btn btn-success btn-sm"
                  id="autorizar"
                  @click="openModal()"
                  v-if="!autorizado"
                >
                  <i class="fa fa-user mr-2"></i> Autorizar no ERP
                </button>
                <button
                  type="button"
                  class="btn btn-danger btn-sm"
                  id="desautorizar"
                  @click="openModalDesautorizar()"
                  v-else
                >
                  <i class="fa fa-user mr-2"></i> Desautorizar no ERP
                </button>
                <span v-if="autorizado" class="ml-2">
                  <b>Usuário autorizado:</b> {{ dados_erp.sigla }} - {{ dados_erp.logname }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal para autorizar no ERP -->
    <Modal
      modalId="modalLoginErp"
      title="Autorizar no ERP"
    >
      <template #body>
        <div class="form-group">
          <label for="siglaErp">Sigla ERP:</label>
          <input
            type="text"
            class="form-control form-control-sm"
            id="siglaErp"
            name="siglaErp"
            v-model="form.siglaErp"
          />
        </div>

        <div class="form-group">
          <label for="loginErp">Login ERP:</label>
          <input
            type="text"
            class="form-control form-control-sm"
            id="loginErp"
            name="loginErp"
            v-model="form.loginErp"
          />
        </div>

        <div class="form-group">
          <label for="senhaErp">Senha ERP:</label>
          <input
            type="password"
            class="form-control form-control-sm"
            id="senhaErp"
            name="senhaErp"
            v-model="form.senhaErp"
          />
        </div>
      </template>
      <template #footer>
        <button
          type="button"
          class="btn btn-primary btn-sm"
          @click="autorizar()"
        >
          Autorizar
        </button>
        <button
          type="button"
          class="btn btn-danger btn-sm ml-2"
          @click="closeModal()"
        >
          Cancelar
        </button>
      </template>
    </Modal>

    <!-- Modal para desautorizar no ERP -->
    <Modal
      modalId="modalDesautorizarErp"
      title="Desautorizar no ERP"
    >
      <template #body>
        <p>Deseja realmente desautorizar o ERP?</p>
        <p><b>Usuário autorizado:</b> {{ dados_erp.sigla }} - {{ dados_erp.logname }}</p>
      </template>
      <template #footer>
        <button
          type="button"
          class="btn btn-danger btn-sm"
          @click="desautorizar()"
        >
          Desautorizar
        </button>
        <button
          type="button"
          class="btn btn-secondary btn-sm ml-2"
          @click="closeModalDesautorizar()"
        >
          Cancelar
        </button>
      </template>
    </Modal>
  </div>
</template>

<script>
import api, { api_erp } from '@/api'

import Modal from '../Modal.vue';

const form = {
  siglaErp: '',
  loginErp: '',
  senhaErp: ''
};

const dados_erp = {
  sigla: '',
  logname: ''
};

export default {
  name: 'ConfigElocaErp',
  components: {
    Modal,
  },
  data() {
    return {
      form: { ...form },
      dados_erp: { ...dados_erp}
    };
  },
  mounted() {
    this.getDadosErp();
  },
  methods: {
    openModal() {
      $('#modalLoginErp').modal('show');
    },
    closeModal() {
      $('#modalLoginErp').modal('hide');
    },
    openModalDesautorizar() {
      $('#modalDesautorizarErp').modal('show');
    },
    closeModalDesautorizar() {
      $('#modalDesautorizarErp').modal('hide');
    },
    async autorizar() {
      try {
        const responseErp = await api_erp.post('/app/logar', {
          empresa: this.form.siglaErp,
          logname: this.form.loginErp,
          senha: this.form.senhaErp,
          crm: 1
        });

        const response = await api.post('/painel/config-eloca-erp', {
          token_erp: responseErp.data.access_token,
          empresa_erp: this.form.siglaErp,
          logname_erp: this.form.loginErp
        });

        window.showToastSuccess('body', response.data.message);
        this.dados_erp.sigla = this.form.siglaErp.toUpperCase();
        this.dados_erp.logname = this.form.loginErp.toUpperCase();
      } catch (error) {
        const errors = error.response.data[0];
        let message = '';
        for (const field in errors) {
          errors[field].forEach(item => {
            if (field === 'logname') {
              message += `Login ERP: ${item} </br>`;
            } else if (field === 'senha') {
              message += `Senha ERP: ${item} </br>`;
            } else if (field === 'empresa') {
              message += `Sigla ERP: ${item} </br>`;
            }
          });
        }
        if (message !== '') {
          window.showToastDanger('body', message);
        }
        if (error.response.data.mensagem) {
          window.showToastDanger('body', error.response.data.mensagem);
        } else if (error.response.data.message) {
          window.showToastDanger('body', error.response.data.message);
        } else {
          window.showToastDanger('body', 'Erro ao autorizar no ERP');
        }
      } finally {
        this.form = { ...form };
        this.closeModal();
      }
    },
    async getDadosErp() {
      try {
        const response = await api.get('/painel/config-eloca-erp/dados-erp');
        this.dados_erp.sigla = response.data.data.empresa_erp;
        this.dados_erp.logname = response.data.data.logname_erp;
      } catch (error) {
        console.error('Erro ao buscar dados do ERP:', error);
      }
    },
    async desautorizar() {
      try {
        const response = await api.post('/painel/config-eloca-erp/desautorizar');
        window.showToastSuccess('body', response.data.message);
        this.dados_erp = { ...dados_erp };
      } catch (error) {
        window.showToastDanger('body', 'Erro ao desautorizar no ERP');
      } finally {
        this.closeModalDesautorizar();
      }
    }
  },
  computed: {
    autorizado() {
      return this.dados_erp.sigla !== '' && this.dados_erp.sigla !== null && this.dados_erp.logname !== '' && this.dados_erp.logname !== null;
    }
  }
}
</script>
